const defaultState = {
  filter: {
    amenities: [],
    price: { from: 0, to: 0 },
    specialConditions: [],
    propertyTypes: [],
    adType: null,
    zones: [],
    rooms: 0,
    bathrooms: 0,
    adTypes: []
  },
  searchText: null
};

export default defaultState;
